import React, { Component } from 'react';
import { Form, Icon, Input, Button, Row, Col } from 'antd';
import {connect} from 'react-redux';
import {resetPassword} from '../users/actions';
import { ROUTE } from '../../common/constant';
import { Link } from 'react-router-dom';

import './styles.css';

class Index extends Component {

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.resetPassword(values.email);
      }
    });
  };



  render() {
    const { userAdd } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <div className='container'>
        <Row>
          <div className='form-container'>
            <Row>
              <div>
                <img
                  alt='logo'
                  src={require('../../assets/TeamKids-Logo_Orange_CMYK-1.png')}
                  width='100'
                  height='100'
                />
                <span>
                  <div className='title-holiday'>Holiday Period Planner</div>
                </span>
              </div>
            </Row>
            <Row>
              <div className='title-forgot-password'>Forgot your password?</div>
              <div className='form-forgot-password'>
                <Form onSubmit={this.handleSubmit} layout='vertical'>
                  <Form.Item>
                    {getFieldDecorator('email', {
                      rules: [{ required: true, message: 'Please input your email!' }],
                    })(
                      <Input
                        prefix={<Icon type='user' style={{ color: 'rgba(0,0,0,.25)' }} />}
                        placeholder='Email'
                      />
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Col span={4}>
                      <Button
                        className='button-reset-password' 
                        loading={userAdd.isLoading}
                        htmlType='submit'>
                        {!userAdd.isLoading ? 'Reset Password' : ''} 
                      </Button>
                    </Col>
                    <Col span={8}></Col>
                    <Col span={12}>
                      <Link className='recover-my-password' to={ROUTE.LAYOUT + ROUTE.LOGIN}>
                        Back to Login page
                      </Link>
                    </Col>
                  </Form.Item>
                </Form>
              </div>
            </Row>
          </div>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userAdd: state.userAdd
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (param) => dispatch(resetPassword(param))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(Index));
